/**
* 基础菜单 拼团管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>营销管理</el-breadcrumb-item>
        <el-breadcrumb-item>拼团管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sales_name" placeholder="商品销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addGroupdialog" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editgroup" class="edit-button">修改</el-button>
        <!--        <el-button size="small" type="danger" @click="delgroup">删除</el-button>-->
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="sale_name" label="商品销售名称" min-width="160" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div style="white-space: pre;" class="over_text_1">{{scope.row.sale_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="group_price" label="拼团价" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.group_price||scope.row.group_price==0">￥{{scope.row.group_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="group_suc_num" label="成团数" width="100">
        </el-table-column>
        <el-table-column prop="join_group_num" label="参团数" width="100">
        </el-table-column>
        <el-table-column prop="creater_name" label="创建人" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="135">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="135">
        </el-table-column>
        <el-table-column prop="status" label="有效状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="seq" label="排序号" width="100">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="groupDialogVisible"
               :before-close="handleClose"
               width="30%"
               center>
      <el-form :model="groupForm" :rules="grouprules" ref="groupForm" label-width="155px" class="groupForm">
        <el-form-item label="商品销售名称" prop="sales_id">
          <el-select v-model="groupForm.sales_id" filterable placeholder="请选择商品销售名称" clearable  :disabled="isDisable"
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusProductName()" @change="changeProductName()" @clear="clear()">
            <el-option :title="item.sale_name"
                       v-for="item in productData"
                       :key="item.sale_id"
                       :label="item.sale_name"
                       :value="item.sale_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productHandleSizeChange"
                             @current-change="productHandleCurrentChange"
                             :current-page.sync="productCurrentPage"
                             :page-size="productPagesize"
                             layout="total, prev, pager, next"
                             :total="productTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="拼团价" prop="group_price" class="r55 relative">
          <el-input v-model="groupForm.group_price" clearable placeholder="请输入拼团价" maxlength="8">
          </el-input>
        </el-form-item>
        <el-form-item label="成团数" prop="group_suc_num" class="r55 relative">
          <el-input v-model="groupForm.group_suc_num" auto-complete="off" clearable placeholder="请输入成团数" maxlength="8">
          </el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="seq" class="r55 relative">
          <el-input v-model="groupForm.seq" auto-complete="off" clearable placeholder="请输入排序号" maxlength="8">
          </el-input>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time" class="relative">
          <template>
            <div class="block">
              <el-date-picker
                  v-model="groupForm.end_time"
                  type="datetime"
                  placeholder="请选择结束时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm('groupForm')">重 置</el-button>
            <el-button type="primary" @click="saveSort('groupForm')">保存</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  groupList,     // 拼团管理-列表
  groupAdd,      // 拼团管理-新增
  groupUpdate,   // 拼团管理-修改
  groupDelete,    // 拼团管理-删除-设置无效
  groupDetail,    // 拼团管理-详情
  productSaleList,
  productList,
  groupEnabled, custInfo
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToTime} from "../../utils/util";

  export default {
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入成团数'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateSalePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入拼团价'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('输入长度过长或格式不正确'));
        } else {
          return callback();
        }
      };
      var validateSeq = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))||value < 3) {
          return callback(new Error('请输入3以上的正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false,
        addProductDialogVisible: false,
        groupDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        selectTableData: [],
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          sales_name: '',
          product_code: ''
        },
        grouprules: {
          sales_id: [{required: true, message: '请选择商品销售名称', trigger: 'blur'}],
          group_price: [{required: true, validator: validateSalePrice,trigger: 'blur'}],
          group_suc_num: [{required: true, validator: validateNum, trigger: 'blur'}],
          seq: [{required: true, validator: validateSeq, trigger: 'blur'}],
          end_time: [{required: true, message: '请选择结束时间', trigger: 'change'}],
        },
        groupForm: {
          id: '',
          sales_id: '',
          group_price: '',
          group_suc_num: '',
          seq: '',
          end_time: '',
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        // rules表单验证
        rules: {},
        dialogImageUrl: '',
        dialogVisible: false,
        imgUrl: '',
        product_id: '',
        product_name: '',
        form: {
          image: ''
        },
        isCanSubmit: true,
        productData: [],
        giftProductData: [],
        //分页
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        saleName: '',
        selectedsaleName: '',
        small: true,
        isDisable:false
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      clear() {
        this.getProduct()
        this.productCurrentPage = 1
        this.saleName = ''
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getProduct(this.saleName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getProduct(this.saleName)
      },
      focusProductName() {
        if (!this.selectedsaleName) {
          this.saleName = ''
          this.getProduct('')
        }
      },
      changeProductName() {
        this.productCurrentPage = 1;
        this.productData.forEach((item) => {
          if (item.sale_id == this.groupForm.sales_id) {
            this.selectedsaleName = item.sale_name;
            this.getProduct(item.sale_name)
          }
        })
      },
      getProduct(saleName) {
        let parameter = {
          page: this.productCurrentPage,
          rows: 10,
          keyword: saleName,
          put_away_status: '75',
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleName = ''
              }
              this.productData = res.rows;
              this.productTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.saleName = val;
        this.getProduct(val)
      },
      // 分页插件事件
      productCallFather() {
        this.getProduct(this.formInline)
      },
      // 新增按扭
      addGroupdialog() {
        this.groupDialogVisible = true;
        this.dialogTitle = '新增拼团';
        this.isDisable = false;
        this.groupForm = {
          id: '',
          sales_id: '',
          group_price: '',
          group_suc_num: '',
          seq: '',
          end_time: ''
        }
        this.getProduct();
      },
      // 修改按钮
      editgroup() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改拼团';
        this.isDisable = true;
        this.groupDialogVisible = true;
        this.selectedsaleName = this.selectTableData[0].sale_name
        this.getProduct(this.selectTableData[0].product_code)
        this.loading = true
        groupDetail(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.groupForm = {
                id: res.content.id,
                sales_id: res.content.sales_id,
                group_price: res.content.group_price,
                group_suc_num: res.content.group_suc_num,
                seq: res.content.seq,
                end_time: res.content.end_time
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      addgroup(id) {
        this.addProductDialogVisible = true;
        this.productId = id;
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.getProduct('')
      },
      // 保存
      saveSort(formName) {
        if (this.groupForm.end_time) {
          this.groupForm.end_time = timestampToTime(this.groupForm.end_time)
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增拼团') {
              groupAdd(this.groupForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加拼团!'
                    });
                    this.groupDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.groupForm.id = this.productId;
              groupUpdate(this.groupForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改拼团!'
                    });
                    this.groupDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      changeStatus(id, status) {
        if (!status) {
          groupDelete(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          groupEnabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }

      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        groupList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["groupForm"].resetFields();
        this.groupDialogVisible = false;
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_name == cell.innerText || row.sale_name == cell.innerText || row.product_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }

</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .groupForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .groupForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .groupForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .groupForm .el-input--small {
    width: 320px;
  }

  /deep/ .groupForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .groupForm .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/Marketing/groupManage.vue